import DamageFilterForm from "./damage-filter-form";

const DamageForms = {
    Filter: DamageFilterForm
};

export default DamageForms;
